/**
 * Name: SCHEDULE CUSTOMER SONG
 * Author: @Gaurav
 * Date: 23-07-2021
 */
export default function reducer(
  state = {
    status: 'uninitiated',
    result: [],
  },
  action
) {
  switch (action.type) {
    case 'SCHEDULE_CUSTOMER_SONG_INITIATED': {
      return { ...state, status: 'initiated' };
    }
    case 'SCHEDULE_CUSTOMER_SONG_SUCCESS': {
      return { ...state, status: 'success', result: action.payload };
    }
    case 'SCHEDULE_CUSTOMER_SONG_FAILED': {
      return { ...state, status: 'failed', result: action.payload };
    }
    default: {
      return state;
    }
  }
}
